import { executePost } from "../../../Utils/ServiceMethods";
import { toast } from "react-toastify";
import { CityId, removeUserCredentials } from "../../../Utils/LocalStorage";
import { SessionTimeout } from "../../../Utils/ErrorMessages";

export const MessageDetailApi = async (cb) => {
  const id = CityId();
  //   const is_switched_value = getBusinessSwitched();
  //   const acitve_business_id = getactiveBuId();
  // console.log("is_switched_value ===",acitve_business_id,id)
  let payload = {
    api_method: "get",
    mms_city_id: parseInt(id),
    search_value: "",
  };
  try {
    const response = await executePost("/chat/message/mms-user", payload);
    const activeCouponData = response.data ? response.data : {};
    return response;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
